export default __webpack_public_path__ + "static/media/online-doctor.cdcfed55.png";